<template>
  <v-container>

    <v-row class="display-1 mt-8">
      Returns
    </v-row>
    <div>

      <v-tabs v-model="activeTab" centered fixed-tabs style="max-width: 800px;" class="mx-auto">
        <v-tab>In process</v-tab>
        <v-tab>Complete</v-tab>
      </v-tabs>

    </div>
    <!-- end toolbar container, to prevent parent flexer shrinking children linke hlines -->

    <!-- MAIN CONTENT -->
    <div>
      <returns-in-process v-if="activeTab === 0"></returns-in-process>
    </div>

  </v-container>
</template>

<script>
import ReturnsInProcess from './ReturnsInProcess'

export default {
  name: 'returns',
  components: {
    ReturnsInProcess
  },
  data () {
    return {
      activeTab: 0
    }
  },
  watch: {
    /* activeTab (nv) {
      this.$router.push({ path: '', query: {}})
    } */
  }
}
</script>
